var map = {
	"./img0.png": "bc15",
	"./img1.png": "94a1",
	"./img2.png": "b73a",
	"./img3.png": "d473",
	"./img4.png": "9977",
	"./img5.png": "51ff",
	"./img6.png": "59bf",
	"./img7.png": "1a38",
	"./img8.png": "7ab8",
	"./img9.png": "c83d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fd5";